import React, { useMemo } from 'react';
import s from './chat-window.module.scss';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import { IconChevronLeft, IconWifiOff, IconLoader } from '@tabler/icons-react';
import { useChatStore } from '@entities/messanger';
import { MessageList } from '@features/messanger/message-list';
import { SendMessageForm } from '@features/messanger/send-message';

export const ChatWindow = ({ isMobile, profile, onRead }) => {
  const navigate = useNavigate();
  const { selectedChat, selectChat, wsConnected, wsReconnecting } = useChatStore(
    useShallow((state) => ({
      selectedChat: state.selectedChat,
      selectChat: state.selectChat,
      wsConnected: state.wsConnected,
      wsReconnecting: state.wsReconnecting,
    }))
  );

  const participant = useMemo(() => selectedChat?.participants?.[0], [selectedChat]);

  // Переход в профиль преподавателя доступен только ученику
  const isTeacherProfileLink =
    profile?.role === 'student' && participant?.role === 'teacher';

  const handleParticipantClick = () => {
    if (isTeacherProfileLink) {
      navigate(`/teacher/${participant?.teacher_slug}`);
    }
  };

  if (!selectedChat) {
    return (
      <div className={s.withoutChat}>
        <span>Выберите чат, чтобы начать общаться</span>
      </div>
    );
  }

  return (
    <div className={classNames(s.messengerWrapper, isMobile && s.mobile)}>
      <div className={s.messengerHeader}>
        {isMobile && (
          <button onClick={() => selectChat(null)} className={s.backBtn}>
            <IconChevronLeft />
          </button>
        )}
        <div
          className={classNames(
            s.participant,
            isTeacherProfileLink && s.clickable
          )}
          onClick={handleParticipantClick}
        >
          <div className={s.avatar}>
            <img
              src={
                participant?.role === 'service'
                  ? '/logo192.png'
                  : participant?.avatar
                  ? process.env.REACT_APP_STORAGE_URL + participant?.avatar
                  : process.env.REACT_APP_STORAGE_URL + 'images/default_avatar.png'
              }
              alt=""
            />
          </div>
          <div className={s.headerInfo}>
            <div className={s.name}>{participant?.name}</div>
          <div
            className={classNames(
              s.status,
              participant?.online && s.online
            )}
          >
            {wsReconnecting ? (
              <span className={s.reconnecting}>
                <IconLoader size={12} className={s.spin} /> Переподключение…
              </span>
            ) : !wsConnected ? (
              <span className={s.offline}>
                <IconWifiOff size={12} /> Нет соединения
              </span>
            ) : participant?.online ? (
              'В сети'
            ) : (
              'Не в сети'
            )}
          </div>
        </div>
      </div>
      </div>

      <MessageList key={selectedChat?.id} profile={profile} onRead={onRead} />

      {participant?.role !== 'service' && (
        <SendMessageForm chatId={selectedChat.id} disabled={!wsConnected} />
      )}
    </div>
  );
};
